import { useEffect } from 'react'
import { useOnboardingStore } from '../../../store/onboarding-store'
import styles from './PrioritiesList.module.css'
import { getDetectedLanguage } from '../../../i18n'

interface PrioritiesListProps {
  selectedPriorities: number[]
  setSelectedPriorities: React.Dispatch<React.SetStateAction<number[]>>
}

const PrioritiesList = ({
  selectedPriorities,
  setSelectedPriorities,
}: PrioritiesListProps) => {
  const { fetchTracks, tracks } = useOnboardingStore()

  useEffect(() => {
    fetchTracks()
  }, [fetchTracks])

  const handlePriorityClick = (id: number) => {
    if (selectedPriorities.includes(id)) {
      setSelectedPriorities(selectedPriorities.filter((p) => p !== id))
    } else {
      setSelectedPriorities([...selectedPriorities, id])
    }
  }

  const getPriorityStyle = (id: number) => {
    if (selectedPriorities.includes(id)) {
      return styles.selectedPriority
    }
    return ''
  }

  return (
    <div className={styles.priorities}>
      {tracks.map((track) => (
        <div
          key={track.id}
          className={`${styles.priority} ${getPriorityStyle(track.id)}`}
          onClick={() => handlePriorityClick(track.id)}
        >
          <p>{track.shortDescription[getDetectedLanguage()]}</p>
        </div>
      ))}
    </div>
  )
}

export default PrioritiesList
